import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HighlightRemoveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"highlight_remove"}/>
}
